export default __webpack_public_path__ + "static/hero-video-7cdaa8f29c99f4b9161344e249d7ba23.mp4";